// Imports
import Vue from 'vue'
import Router from 'vue-router'
import { trailingSlash } from '@/util/helpers'
import {
  layout,
  route,
} from '@/util/routes'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior: (to, from, savedPosition) => {
    if (to.hash) return { selector: to.hash }
    if (savedPosition) return savedPosition

    return { x: 0, y: 0 }
  },
  routes: [
    {
      path: '/',
      redirect: to => {
        return {
          name: 'Dashboard',
        }
      },
    },
    layout('Default', [
      route('Dashboard', null, 'dashboard'),
      route('Users', null, 'users'),
      route('VideoReviews', null, 'video_reviews'),
      route('AdminForm', { default: 'AdminForm' }, 'admin/new'),
      route('Profile', null, 'users/profile/:id'),
      route('Modalities', null, 'modalities'),
      route('CreateModality', { default: 'ModalityForm' }, 'modalities/new'),
      route('EditModality', { default: 'ModalityForm' }, 'modalities/:id'),
      route('Specializations', null, 'specializations'),
      route('CreateSpecialization', { default: 'SpecializationForm' }, 'specializations/new'),
      route('EditSpecialization', { default: 'SpecializationForm' }, 'specializations/:id'),
      route('Orders', null, 'orders/:email?'),
      route('OrderDetails', null, 'orders/details/:id'),
      route('OrderReport', { default: 'OrderReport' }, 'order_report'),
      route('Plans', null, 'plans'),
      route('CreatePlan', { default: 'PlanForm' }, 'plan/new'),
      route('PlanDetails', { default: 'PlanDetails' }, 'plan_details/:id'),
      route('EditPlan', { default: 'PlanForm' }, 'plan/:id'),
      route('SubscriptionReport', { default: 'SubscriptionReport' }, 'subscription_report/:id'),
      route('PlanCoupons', null, 'plan_coupons'),
      route('CreatePlanCoupon', { default: 'PlanCouponForm' }, 'plan_coupon/new'),
      route('EditPlanCoupon', { default: 'PlanCouponForm' }, 'plan_coupon/:code'),
      route('PlanCouponReport', { default: 'PlanCouponReport' }, 'plan_coupon/reports/:id'),
      route('DiscountCoupons', null, 'coupons'),
      route('CreateCoupon', { default: 'DiscountCouponForm' }, 'coupon/new'),
      route('EditCoupon', { default: 'DiscountCouponForm' }, 'coupon/:id'),
      route('DiscountCouponReport', { default: 'DiscountCouponReport' }, 'coupon/reports/:id'),
      route('Subscriptions', null, 'subscriptions/:plan?/:email?'),
      route('SubscriptionDetails', { default: 'SubscriptionDetails' }, 'subscription/details/:id'),
      route('MessageTemplates', null, 'message_templates'),
      route('EditMessageTemplate', { default: 'MessageTemplateForm' }, 'message_template/:id'),
      route('Reviews', null, 'reviews'),
      route('Faqs', null, 'faqs'),
      route('CreateFaq', { default: 'FaqForm' }, 'faqs/new'),
      route('EditFaq', { default: 'FaqForm' }, 'faqs/:id'),
      route('Invites', null, 'invites'),
      route('Testimonials', null, 'testimonials'),
      route('CreateTestimonial', { default: 'TestimonialForm' }, 'testimonials/new'),
      route('EditTestimonial', { default: 'TestimonialForm' }, 'testimonial/:id'),
      route('TermsOfUse', { default: 'TermsOfUse' }, 'terms'),
      route('PrivacyPolicy', { default: 'PrivacyPolicy' }, 'privacy_policy'),
      route('Settings', { default: 'Settings' }, 'settings'),
      route('EditSetting', { default: 'SettingForm' }, 'settings/:id'),
      route('BlogCategories', null, 'blog_categories'),
      route('CreateBlogCategory', { default: 'BlogCategoryForm' }, 'blog_category/new'),
      route('EditBlogCategory', { default: 'BlogCategoryForm' }, 'blog_category/:id'),
      route('BlogPosts', null, 'blog_posts'),
      route('CreateBlogPost', { default: 'BlogPostForm' }, 'blog_post/new'),
      route('EditBlogPost', { default: 'BlogPostForm' }, 'blog_post/:id'),
      route('DashboardNotifications', null, 'dashboard_notifications'),
      route('CreateDashboardNotification', { default: 'DashboardNotificationForm' }, 'dashboard_notifications/new'),
      route('EditDashboardNotification', { default: 'DashboardNotificationForm' }, 'dashboard_notifications/:id'),
      route('Accesses', null, 'accesses'),
      route('Content', null, 'content'),
      route('CreateContent', { default: 'ContentForm' }, 'content/new'),
      route('EditContent', { default: 'ContentForm' }, 'content/:id'),
      route('TrafficLightEvents', { default: 'TrafficLights' }, 'traffic_lights/events'),
      route('ContactMessages', { default: 'ContactMessages' }, 'contact_messages'),
      route('ContactMessageRead', { default: 'ContactMessageRead' }, 'contact_messages/:id'),
      route('Redirects', null, 'redirects'),
      route('CreateRedirect', { default: 'RedirectForm' }, 'redirects/new'),
      route('EditRedirect', { default: 'RedirectForm' }, 'redirect/:id'),
      route('HowToPublishClasses', { default: 'Pages/HowToPublishClasses' }, 'pages/how_to_publish_classes'),
      route('Blocks', { default: 'Pages/Blocks' }, 'blocks'),
      route('CreateBlock', { default: 'Pages/BlockForm' }, 'blocks/create'),
      route('EditBlock', { default: 'Pages/BlockForm' }, 'blocks/:id'),
      route('Pages', { default: 'Pages/List' }, 'pages'),
      route('CreatePage', { default: 'Pages/PageForm' }, 'pages/create'),
      route('EditPage', { default: 'Pages/PageForm' }, 'pages/:id'),
    ]),
    layout('Unauthenticated', [
      route('Login', null, 'login'),
    ]),
  ],
})

router.beforeEach((to, from, next) => {
  return to.path.endsWith('/') ? next() : next(trailingSlash(to.path))
})

export default router
